<template>
    <v-container>
        <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                dense
                class="elevation-3"
                @click:row="displayResource"
        >
        </v-data-table>
        <v-spacer />
        <v-tooltip bottom>
            <template v-if="!showInReadMode" v-slot:activator="{ on }">
                <v-btn class="mr-1 mt-6 float-right" fab color="success" small @click="dialog = true" v-on="on">
                    <v-icon small>mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Add</span>
        </v-tooltip>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Add {{resource.toLocaleUpperCase()}}</span>
                    <v-text-field color="success" :loading="saving" disabled></v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <dynamic-element :form_content="element_list" :disabled="false" :booking="newResource" />
                    </v-container>
                    <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="handleDialog(false)">Close</v-btn>
                    <v-btn color="blue darken-1" text @click="handleDialog(true)">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="readOnlyDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{resource.toLocaleUpperCase()}} Info</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <dynamic-element :form_content="element_list" :booking="existingResource" />
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="handleReadOnlyDialog(false)">Close</v-btn>
                  <v-btn color="blue darken-1" text @click="handleReadOnlyDialog(true)">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import ResourceAPI from '../../api/resource_api'
    import DynamicElement from "../../views/dashboard/component/DynamicElement"
    import { mapActions, mapState } from "vuex"

    export default {
        name: "BaseResource",
        components: { DynamicElement },
        props: ['booking_id', 'resource', 'headers', 'element_list', 'dataDecoration', 'additionalSaveOperation', 'readOnly'],
        data: () => ({
            items: [],
            loading: false,
            saving: false,
            dialog: false,
            readOnlyDialog: false,
            newResource: {},
            existingResource: {}
        }),
        mounted() {
            this.getData();
        },
        computed: {
            ...mapState({ 'currentUser': 'user' }),
          showInReadMode() {
              return this.readOnly || false;
          }
        },
        methods: {
            ...mapActions({
                showSnackbar: "SHOW_SNACKBAR",
            }),
            async getData() {
                this.loading = true;
                const { data } = await ResourceAPI.list({ resource: this.resource, booking_id: this.booking_id })
                this.items = data.Items && data.Items.sort((a, b) => new Date(a.date) - new Date(b.date)) || []
                if(this.dataDecoration) {
                    this.dataDecoration(this.items);
                }
                this.loading = false;
            },
            async addResource() {
                if (this.currentUser && this.currentUser.name) {
                    this.newResource.created_by = this.currentUser.name;
                }

                try {
                    this.saving = true;
                    if(this.additionalSaveOperation) {
                        await this.additionalSaveOperation(this.booking_id, this.newResource)
                    }
                    await ResourceAPI.addResource({resource: this.resource, booking_id: this.booking_id, ...this.newResource})
                    this.resetDialog();
                    this.showSnackbar({ text: `${this.resource} created successfully`, show: true, color: 'success' })
                    //update table
                    this.getData();
                } catch (e) {
                    console.log(e)
                    this.showSnackbar({ text: `Error while saving ${this.resource}`, show: true, color: 'error' })
                }
                this.saving = false;
            },
            async updateResource() {
                if (this.currentUser && this.currentUser.name) {
                    this.existingResource.last_modified_by = this.currentUser.name;
                }

                try {
                    this.saving = true;
                    if(this.additionalSaveOperation) {
                       await this.additionalSaveOperation(this.booking_id, this.existingResource)
                    }
                    await ResourceAPI.updateResource({...this.existingResource})
                    this.resetDialog();
                    this.showSnackbar({ text: `${this.resource} updated successfully`, show: true, color: 'success' })
                    //update table
                    this.getData();
                } catch (e) {
                    console.log(e)
                    this.showSnackbar({ text: `Error while saving ${this.resource}`, show: true, color: 'error' })
                }
                this.saving = false;
            },
            displayResource(resource) {
              if(this.showInReadMode) { return}
                this.existingResource = resource;
                this.readOnlyDialog = true
            },
            resetDialog() {
                this.newResource = {} //reset
                this.existingResource = {};
                this.dialog = false;
                this.readOnlyDialog = false;
            },
            handleDialog(saveFlag) {
                if (!saveFlag) {
                    this.resetDialog();
                }
                else {
                    this.addResource();
                }

            },
            handleReadOnlyDialog(saveFlag) {
                if (!saveFlag) {
                  this.resetDialog();
                }
                else {
                    this.updateResource();
                }
            }
        }
    }
</script>